import globals from '../../../../scripts/modules/globals';
import parameters from '../../../../scripts/modules/parameters';
import selection from '../utility/selection';
import list from '../list';
import map from '../map';
import tabs from './tabs';

// On load get the window parameters and set the right inputs to enabled
const load = ( obj = parameters.get() ) => {
	for ( let key in obj ) {
		let selector, el, arr = [];
		let value = obj[key];
		if ( typeof value !== 'object' ) {
			selector = `.filter__option[data-key='${key}'][data-value='${value}']`;
			el = document.querySelector(selector);
			if ( el ) { el.setAttribute('data-status', 'enabled') }
		} else {
			for ( let item in value ) {
				selector = `.filter__option[data-key='${key}'][data-value='${value[item]}']`;
				el = document.querySelector(selector);
				if ( el ) { el.setAttribute('data-status', 'enabled') }
			}
		}
	}
}

const disableOthers = ( key, value ) => {
	let options = document.querySelectorAll(`.filter__option[data-key="${key}"]`);
	options.forEach( ( option ) => {
		if ( option.getAttribute('data-value') !== value ) {
			option.setAttribute('data-status', 'disabled');
		}
	});
}

const submit = (key, value, type, op = 'add') => {
	parameters.set( key, value, type, op, parameters.getWindow('?filter=true') );
	tabs.update( document.querySelector('.filter__tab.is-active') );
	list.load(true);
	disableOthers(key, value);
	let existsing = document.querySelector(`.filter__option[data-key="${key}"][data-value="${value}"]`);
	if ( existsing ) {
		existsing.setAttribute('data-status', 'enabled');
	}
}

const nullify = () => {
	parameters.set( key, value, type, 'remove', parameters.getWindow('?filter=true') );
	tabs.update( document.querySelector('.filter__tab.is-active') );
	list.load(true);
	disableOthers(key, value);
	let existsing = document.querySelector(`.filter__option[data-key="${key}"][data-value="${value}"]`);
	if ( existsing ) {
		existsing.setAttribute('data-status', 'enabled');
	}
}

const submitInput = ( key, value, type, input ) => {
	if ( input.value && input.value !== value && input.value !== 'undefined' ) {
		submit( key, input.value, type );
		input.setAttribute('data-value', input.value);
	} else {
		if ( parameters.getKey(key) ) submit( key, parameters.getKey(key), type, 'remove' );
		input.setAttribute('data-value', '');
	}
}

const input = () => {
	let inputs = document.querySelectorAll('.filter__option__input');
	inputs.forEach( (input) => {
		let placeholder = input.getAttribute('data-placeholder');
		let key = input.getAttribute('data-key');
		let type = input.getAttribute('data-type');
		let value = parameters.getKey(key) ? parameters.getKey(key) : '';
		input.setAttribute('data-value', value);
		input.value = (value && value !== 'undefined') ? value : '';
		input.onblur = (e) => submitInput( key, value, type, input);
		input.onkeypress = (e) => {
			if(e.keyCode === 13){
				submitInput( key, value, type, input)
			}
		};
		input.value = value ? value : placeholder;
	});
}

const toggle = () => {
	let items = document.querySelectorAll('.filter__item');
	items.forEach( ( item ) => {
		let tab = item.querySelector('.filter__tab');
		item.onclick = (e) => {
			let target = e.target;
			let s = target.getAttribute('data-status');
			let k = target.getAttribute('data-key');
			let v = target.getAttribute('data-value');
			let t = item.getAttribute('data-type');
			let tB = t.split('-', 1)[0] ? t.split('-', 1)[0] : t;
			let tS = t.split('-')[1] ? t.split('-')[1] : t;
			if ( target.classList.contains('filter__option') ) {
				if ( s === 'enabled' ) {
					target.setAttribute('data-status', 'disabled');
					parameters.set( k, v, tB, 'remove', parameters.getWindow('?filter=true') );
				} else {
					target.setAttribute('data-status', 'enabled');
					parameters.set( k, v, tB, 'add', parameters.getWindow('?filter=true') );
					if ( tB !== 'array' ) { disableOthers(k, v); }
				}
				list.load(true);
				tabs.update(tab);
				input();
			}
		}
	});
}

const init = () => {
	load();
	input();
	toggle();
	selection('.filter__menu', '.filter__option');
}

export default {
	load,
	input,
	toggle,
	init
}
